import Image from 'next/image';
import { useState } from 'react';
import styles from '../../styles/sass/layout/CtaCard.module.scss';
import ctaPhoto from '../../../public/img/szabojennifer3.JPG';

export default function CtaCard() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        privacyAccepted: false,
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState('');

    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        setSubmitMessage('');

        try {
            const response = await fetch('/api/contact-cta', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || 'Nem sikerült elküldeni az űrlapot.');
            }

            setSubmitMessage('Köszönöm! Az üzenetet sikeresen megkaptam.');
            setFormData({
                name: '',
                email: '',
                phone: '',
                message: '',
                privacyAccepted: false,
            });
        } catch (error) {
            setSubmitMessage(error.message || 'Hiba történt a beküldés során.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <section className={styles.ctaSection}>
            <div className={styles.ctaCard}>
                <div className={styles.ctaImageContainer}>
                    <Image
                        src={ctaPhoto}
                        alt='Kapcsolatfelvétel'
                        className={styles.ctaImage}
                        fill
                        sizes='(max-width: 1200px) 100vw, 42vw'
                    />
                </div>
                <div className={styles.ctaContent}>
                    <h2 className={styles.ctaHeading}>Vedd fel velem a kapcsolatot</h2>
                    <p className={styles.ctaLead}>
                        Ha úgy érzed, itt az idő támogatást kérni, foglalj időpontot,
                        és induljunk el együtt egy kiegyensúlyozottabb, önazonosabb élet felé.
                    </p>

                    <form className={styles.ctaForm} onSubmit={handleSubmit}>
                        <input
                            className={styles.ctaInput}
                            type='text'
                            name='name'
                            placeholder='Név'
                            value={formData.name}
                            onChange={handleInputChange}
                            required
                        />
                        <input
                            className={styles.ctaInput}
                            type='email'
                            name='email'
                            placeholder='E-mail cím'
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                        />
                        <input
                            className={styles.ctaInput}
                            type='tel'
                            name='phone'
                            placeholder='Telefonszám'
                            value={formData.phone}
                            onChange={handleInputChange}
                        />
                        <textarea
                            className={styles.ctaTextarea}
                            name='message'
                            placeholder='Üzenet'
                            value={formData.message}
                            onChange={handleInputChange}
                            rows={6}
                            required
                        />

                        <label className={styles.ctaConsentRow}>
                            <input
                                type='checkbox'
                                name='privacyAccepted'
                                checked={formData.privacyAccepted}
                                onChange={handleInputChange}
                                required
                            />
                            <span>
                                Elfogadom az <a href='/Szabo_Jennifer_Adatkezelesi_tajekoztato.pdf' target='_blank' rel='noopener noreferrer'>adatkezelési tájékoztatót</a>.
                            </span>
                        </label>

                        <button className={styles.ctaSubmitButton} type='submit' disabled={isSubmitting}>
                            {isSubmitting ? 'Küldés...' : 'Elküldöm'}
                        </button>

                        {submitMessage && <p className={styles.ctaSubmitMessage}>{submitMessage}</p>}
                    </form>
                </div>
            </div>
        </section>
    );
}
